
<!-- Modal -->
<div class="modal fade" *ngIf="adminApi.isLoggedIn()" id="{{modalid}}" tabindex="-1" aria-labelledby="suggestskillModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <form class="" [formGroup]="Form" (ngSubmit)="onSubmit(Form)">
        <div class="modal-body pt-4">
          <h5 class="card-title">{{user?"Edit User":"Add User"}}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            <div class="row">
              <div class="form-group">
                <label for="" class="form-label d-block">Sign up as:</label>
                <div class="popover-wrap-2 ms-2">
                    <input type="radio" formControlName="form_type" (click)="changeFormType()" [checked]="f2['form_type'].value=='coach'" value="coach" name="form_type" id="coach">
                    <label for="coach" class="d-inline-block ms-2 form-label">
                        <span>Coach</span>
                    </label>
                    <div class="popover-content">A single account with access to our video library. Ideal for smaller gyms and individual coaches.</div>
                </div>
                <div class="popover-wrap-2 ms-2">
                    <input type="radio" formControlName="form_type"(click)="changeFormType()" [checked]="f2['form_type'].value=='gymowner'" value="gymowner" name="form_type" id="gymowner">
                    <label for="gymowner" class="d-inline-block ms-2 form-label">
                        <span>Gym Owner</span>
                    </label>
                    <div class="popover-content">3 Coach accounts (2 to be assigned by the main account) that can share lists. Ideal of larger programs with Recreation or Competitive Directors.</div>
                </div>
                <div class="popover-wrap-2 ms-2">
                    <input type="radio" formControlName="form_type"(click)="changeFormType()" [checked]="f2['form_type'].value=='schoolcoach'" value="schoolcoach" name="form_type" id="schoolcoach">
                    <label for="schoolcoach" class="d-inline-block ms-2 form-label">
                        <span>Schoolcoach</span>
                    </label>
                    <div class="popover-content">A single account with access to our video library. Ideal for smaller gyms and individual schoolcoaches.</div>
                </div>
              </div>
            </div>
            <div class="row">
                <div class="{{!this.user?'col-sm-6':'col-sm-12'}}">
                    <div class="form-group">
                        <label for="emailInput" class="form-label">Your Email address</label>
                        <input type="email" class="form-control" formControlName="email" id="emailInput">
                        <div class="invalid-feedback d-block"
                            *ngIf="(f2['email'].errors?.['required'] || f2['email'].errors?.['email']) && (f2['email'].dirty || f2['email'].touched)">
                            Please fill valid email.
                        </div>
                    </div>
                </div>
                <div class="col-sm-6" *ngIf="!this.user">
                    <div class="form-group">
                        <label for="emailInput" class="form-label">Re-Enter Your Email address</label>
                        <input type="email" class="form-control" formControlName="re_email" id="emailInput">
                        <div *ngIf="f2['re_email'].touched && f2['re_email'].invalid" class="invalid-feedback d-block">
                            <div *ngIf="f2['re_email'].errors['confirmedValidator']">Email and Re-Enter Email must be match.</div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6" *ngIf="!this.user">
                  <div class="form-group">
                      <label for="" class="form-label">Create Password:</label>
                      <input type="password" class="form-control" formControlName="password">
                      <div class="invalid-feedback d-block"
                          *ngIf="(f2['password'].errors?.['required'] || f2['password'].errors?.['minlength']) && (f2['password'].dirty || f2['password'].touched)">
                          Please fill 8 character long password.
                      </div>
                  </div>
                  
              </div>
              <div class="col-sm-6"  *ngIf="!this.user">
                  <div class="form-group">
                      <label for="" class="form-label">Re-Enter Password:</label>
                      <input type="password" class="form-control" formControlName="re_password">
                      
                      <div *ngIf="f2['re_password'].touched && f2['re_password'].invalid" class="invalid-feedback d-block">
                          <div *ngIf="f2['re_password'].errors['confirmedValidator']">Password and Re-Enter Password must be match.</div>
                      </div>
                  </div>
              </div>
            </div>
            
                    
            <div class="row">
              <div class="col-sm-6">
                  <div class="form-group">
              <label for="validationFirstName" class="form-label">First name</label>
              <input type="text" class="form-control" id="validationFirstName" formControlName="first_name" value="">
              <div class="invalid-feedback d-block"
                  *ngIf="f2['first_name'].errors?.['required'] && (f2['first_name'].dirty || f2['first_name'].touched)">
                  Please fill first name.
              </div>
            </div>
            </div>
            
            <div class="col-sm-6">
              <div class="form-group">
                <label for="validationLastName" class="form-label">Last name</label>
                <input type="text" class="form-control" id="validationLastName" formControlName="last_name" value="">
                <div class="invalid-feedback d-block"
                    *ngIf="f2['last_name'].errors?.['required'] && (f2['last_name'].dirty || f2['last_name'].touched)">
                    Please fill last name.
                </div>
              </div>
            </div>
          </div>

            
          <div class="row">
            <div class="col-sm-6">
                <div class="form-group">
                  <label for="validationDOB" class="form-label">Date of Birth</label>
                  <div class="input-group">
                      <input type="text" [owlDateTime]="dt2" [owlDateTimeTrigger]="dt2" formControlName="dob" class="form-control mb-0" placeholder="DOB"
                          aria-label="DOB">
                      <div class="input-group-append d-flex" [owlDateTimeTrigger]="dt2">
                          <span class="input-group-text rounded-0"><i class="fa fa-calendar"></i></span>
                      </div>
                  </div>
                  <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
                  <div class="invalid-feedback d-block"
                      *ngIf="f2['dob'].errors?.['required'] && (f2['dob'].dirty || f2['dob'].touched)">
                      Please select dob.
                  </div>
                  <div class="invalid-feedback d-block"
                      *ngIf="f2['dob'].errors?.['futureDate'] && (f2['dob'].dirty || f2['dob'].touched)">
                      Date of birth cannot be in the future.
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                
                <div class="form-group">
                  <label for="validationCountry" class="form-label">Country</label>
                  <select class="form-select" formControlName="country" id="validationCountry">
                    <option value="">Choose...</option>
                    <ng-container  *ngFor="let country of countries">
                        <option value="{{country.code}}">{{country.name}}</option>
                    </ng-container>
                  </select>
                  <div class="invalid-feedback d-block"
                      *ngIf="f2['country'].errors?.['required'] && (f2['country'].dirty || f2['country'].touched)">
                      Please select country.
                  </div>
                </div>
              </div>
            </div>
            
          <div class="row">
            <div class="col-md-12 form-group" *ngIf="f2['form_type'] && (f2['form_type'].value=='gymowner' || f2['form_type'].value=='coach')">
              <label for="validationDefaultGym" class="form-label">Gym / Team Name</label>
              <input type="text" class="form-control" formControlName="gym_name" id="validationDefaultGym" value="">
              <div class="invalid-feedback d-block"
                  *ngIf="f2['gym_name'].errors?.['required'] && (f2['gym_name'].dirty || f2['gym_name'].touched)">
                  Please fill gym name.
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label class="form-label">Subscription</label>
                <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300" formControlName="plan" class="selectpicker font-oswald w-100">
                  
                  <ng-container *ngFor="let data of subscriptions | keyvalue">
                    <optgroup label="{{data.key | titlecase}}" *ngIf="roleMatch(data.key,f2['form_type'].value)">
                      <option value="">Select a plan</option>
                      <option *ngFor="let subscription of data.value" [value]="subscription?.code">{{subscription?.title+" "+subscription.period | titlecase}}</option>
                    </optgroup>
                  </ng-container>
                </select>
                <div class="invalid-feedback d-block"
                    *ngIf="f2['plan']?.errors?.['required'] && f2['plan'].touched && f2['plan']?.invalid">
                    Please select subscription.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary me-3" data-bs-dismiss="modal">Close</button>
          <button type="submit" class="btn btn-dark btn-gold">Submit <i *ngIf="submitting" class="fa fa-spinner fa-spin"></i></button>
        </div>
      </form>
    </div>
  </div>
</div>
